import { AdvancedSearchJobsGetters } from './partials/search-jobs'

export const AdvancedSearchGetters = {
  groupById: state => id => state.query_groups.find(g => g.sequence === id),
  propertiesByGroupId: (state, getters) => id => getters.groupById(id)?.properties || {},
  fieldsByGroupId: (state, getters) => id => getters.propertiesByGroupId(id)?.fields?.searchable_fields || [],
  operatorsByGroupId: (state, getters) => id => getters.propertiesByGroupId(id)?.operators || {},
  nestedParamsInGroup: (state, getters) => id => getters.groupById(id)?.nested_params || [],
  entityParamsInGroup: (state, getters) => id => getters.groupById(id)?.entity_params || {},
  paramsInGroupBySequence: (state, getters) => (id, sequence) => sequence ? getters.nestedParamsInGroup(id).find(n => n.sequence === sequence) : getters.entityParamsInGroup(id),
  // Term Getters
  selectedEntityInGroup: (state, getters) => id => getters.entityParamsInGroup(id)?.entity,
  selectedFieldInParams: (state, getters) => (id, sequence) => getters.paramsInGroupBySequence(id, sequence)?.field,
  selectedOperatorInParams: (state, getters) => (id, sequence) => getters.paramsInGroupBySequence(id, sequence)?.operator,
  selectedTermInParams: (state, getters) => (id, sequence) => getters.paramsInGroupBySequence(id, sequence)?.term,
  // Result Getters
  resultHeaders: state => (state.search_results.columns || []).map(r => ({ text: r.header, value: r.prop_path })),
  resultRows: state => (state.search_results.rows || []).map(r => ({ ...r.value, link_to: r.link_to })),
  resultEntity: state => state.entities.find(e => e.value === state.entity),
  // Saved Query
  searchedQuery: state => {
    return {
      entity: state.entity,
      query_groups: state.query_groups,
      interGroupOperator: state.interGroupOperator,
    }
  },
  showSavedQueriesDialog: state => state.savedQueriesDialog,
  fields: state => state.exportable_fields,
  queryFields: state => state.exportable_fields_query,
  showDialog: state => state.show_export_dialog,
  searchResults: state => state.search_results,
  selectedResults: state => state.selected_results,
  searchableEntities: state => state.entities || [],
  entities: state => state.entities,
  interGroupOperator: state => state.interGroupOperator,
  queryGroups: state => state.query_groups,
  getIndistinctResults: state => state.indistinctResults,
  resultantEntity: state => state.entity,
  ...AdvancedSearchJobsGetters,
}
